import React, { useEffect, useRef, useState } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { buildName, Singleton } from "helper/tools";
import ProgressRing from "../ProgressRing/ProgressRing";
import { handleNivel } from "../../helperFunctions/helpers";
import "./cobranza.css";
import styles from "./cobranzaOther.module.css";
import toolTipStyles from "./../tooltip.module.css";

import { FaPrint } from "react-icons/fa";

//import * as api from "helper/helper";

import "chartjs-plugin-dragdata";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

//import { Line } from "react-chartjs-2";
//import { format } from "date-fns";
//import generateEstadoCuenta from "../Ventas/utils/estadoCuenta";
import generateGO from "../Ventas/utils/estadoCuentaAsociado";
//import toast from "react-hot-toast";

export default function CobranzaKPITable({
  items,
  openItem,
  handleDetail,
  handleSortChange,
  openEstadoCuenta,
  isLoading = false,
}) {
  const theadRef = useRef();

  const tDetalleRef = useRef([]);
  const tDetalleIsShownRef = useRef([]);
  //  const asociadosClientesRef = useRef({});
  //const [asociadosClientes, setAsociadosClientes] = useState({});

  const [areLoading, setAreLoading] = useState(false);

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  const options = {
    responsive: true,
    plugins: {
      dragData: {
        onDragStart: () => {
          console.log("--onDragStart");
        },
        onDragEnd: () => {
          console.log("--onDragEnd");
        },
        dragY: true,
        dragX: false,
        magnet: {
          to: function (value) {
            // Example: Snap to the nearest 5
            return Math.round(value / 5) * 5;
          },
        },
      },
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Month",
        },
      },
      y: {
        title: {
          display: true,
          text: "Value",
        },
        min: 0,
        max: 100,
        ticks: {
          // forces step size to be 50 units
          stepSize: 50,
        },
      },
    },
  };

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Dataset 1",

        data: labels.map(
          () => 100, //  faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Dataset 2",
        data: labels.map(
          () => 50, //faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Dataset 1",
        data: [10, 30, 50, 20, 25, 44, -10],
        borderColor: "pink",
        backgroundColor: "brown",
      },
      {
        label: "Dataset 2",
        data: [100, 33, 22, 19, 11, 49, 30],
        borderColor: "orange",
        backgroundColor: "blue",
      },
    ],
  };

  /*async function toggleDetails(index, asociadoId) {
    console.log(items);
    if (tDetalleIsShownRef.current[index] == null) return;
    /*tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";
    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index]; /

    if (asociadosClientes[asociadoId] != null) {
      showClienteRow(index);
      return;
    }

    /*if (
      tDetalleIsShownRef.current[index] &&
      asociadosClientesRef.current[asociadoId] == null
    ) { /
    if (asociadosClientes[asociadoId] == null) {
      const response = await api.asociadoClientes(asociadoId).catch((error) => {
        toast.error("Error al pedir Niveles.");
        //setIsLoading(false);
      });
      asociadosClientes[asociadoId] = response.data.clientes;
      setAsociadosClientes({ ...asociadosClientes });

      showClienteRow(index);
    }
  }*/
  async function toggleDetails(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  async function openModals(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  function showClienteRow(index) {
    if (items[index].clientes.length === 0) {
      //} == null) {
      tDetalleIsShownRef.current[index] = true;

      const newloading = !areLoading;
      setAreLoading(newloading);

      setTimeout(function () {
        handleDetail(index, () => {
          tDetalleRef.current[index].style.display = "flex";
          tDetalleIsShownRef.current[index] = true;
          setAreLoading(!newloading);

          generatePDF(null, items[index]);

          //  setAsociadosClientes({ index: index });
        });
      }, 500);

      /*  */
      return;
    }
    if (tDetalleIsShownRef.current[index] == null) return;
    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index];
    tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";

    setAreLoading(tDetalleIsShownRef.current[index]);

    generatePDF(null, items[index]);
  }

  function generatePDF(event, item) {
    //onGenerateTicket("b64", item);
    const item2 = {
      cliente: { nombre: "aq1", direcciones: [] },
      ordenVentaDetalles: [
        {
          asociado: { nombre: "rewerw" },
          cliente: { nombre: "aq1", direcciones: [] },
          producto: {
            nombre: "roundo",
          },
          precio: 234,
          cantidad: 2,
          total: 450,
        },
      ],
    };

    /*
  }]

    }

    item.ordenVentaDetalles
    .map(function (info) {
      const nombre = [
        {
          text: info.producto.nombre,
          style: "tProductsBody",
          colSpan: 4,
          lineHeight: 0,
        },
        {},
        {},
        {},
      ];

      const descripcion = [
        { text: info.cantidad, style: "tProductsBody", alignment: "center" },
        {
          text: "",
          style: "tProductsBody",
          alignment: "center",
        },
        {
          text: Singleton.getInstance().format(info.precio),
          style: "tProductsBody",
          alignment: "right",
        },
        {
          text: Singleton.getInstance().format(info.total),
          style: "tProductsBody",
          alignment: "right",
        },
      ];

      const re = [nombre, descripcion];

      return re;
    })
    .flatMap((info) => info);*/
    /*
  const total = Singleton.getInstance().format(item.totalVenta);
  const subTotal = Singleton.getInstance().format(item.subTotalVenta);
  const descuento = Singleton.getInstance().format("0.0");
  //const subTotalLetra = NumeroALetras(item.subtotal)
  const totalLetra = NumeroALetras(item.totalVenta, true);
  //"SON: SEISCIENTOS TREINTA MIL QUINIENTOS CINCO Y CINCO CON 00/100 PESOS",

  const asociadoNombre = buildName(item.asociado, true);
  const clienteNombre = buildName(item.cliente, true);
  let domicilioCliente = "---";
  if (item.cliente.direcciones.length > 0) {
    const address = item.cliente.direcciones[0];
    const infos = [
      address.calle,
      address.noExterior,
      address.colonia,
      address.cp,
      address.ciudad,
      address.estado,
    ];
    domicilioCliente = infos.join(", ");
  }*/

    //
    //onGenerateEstadoCuentaPDF("print", item);
  }

  useEffect(() => {
    tDetalleIsShownRef.current.length = 0;
    tDetalleIsShownRef.current = new Array(items.length).fill(false);

    tDetalleRef.current = new Array(items.length).fill("");
  }, [items]);

  return (
    <>
      <div className="row">
        {/*<h2>Outer Table with Inner Table</h2>*/}

        <table
          className="table table-borderless datable sortable table-hover"
          style={{ backgroundColor: "lightblue" }}
          width="100%"
        >
          <thead className="table-light" style={{ textAlign: "center" }}>
            <tr ref={theadRef}>
              <th
                scope="col"
                data-column="asociadoId"
                style={{ width: "90px", verticalAlign: "middle" }}
                onClick={(event) => handleSort(event)}
              >
                Id
              </th>

              <th
                scope="col"
                data-column="asociadoNombre"
                style={{ textAlign: "center", verticalAlign: "middle" }}
                onClick={(event) => handleSort(event)}
              >
                Asociado
              </th>

              <th
                scope="col"
                data-column="PendienteTotalParcialidad"
                style={{
                  textAlign: "center",
                  width: "130px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Por Pagar
              </th>

              <th
                scope="col"
                data-column="OrdenParcialidades.TotalPagado"
                style={{
                  textAlign: "center",
                  width: "150px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Comisión
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "140px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Adeudo Anterior
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "130px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Intereses
              </th>

              <th
                scope="col"
                data-column="Total"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "150px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Total a Pagar
              </th>
              <th
                scope="col"
                data-column="Total"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "100px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Estado de Cuenta
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <SkeletonTable columnCount={8} rowCount={6} />}
            {!isLoading &&
              items.map((item, index) => {
                const numAsociado = item.asociado.numAsociado ?? "-";

                const nombre = buildName(item.asociado, true);

                const totalPagar = Singleton.getInstance().format(item.total);

                const pendienteTotalParcialidad =
                  Singleton.getInstance().format(
                    item.pendienteTotalParcialidad,
                  );
                const comision = Singleton.getInstance().format(
                  item.totalComision,
                );
                const usoPagina = "-";
                const pagoGuia = "-";

                const ordenParcialidades = item.ordenParcialidades;
                //const parcialidadActual = ordenParcialidades.parcialidadActual;
                //const parcialidadTotal = ordenParcialidades.totalParcialidades;
                //  const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

                /*const parcialidad =
                  ordenParcialidades.productoParcialidades[parcialidadActual];*/
                /*  const pagoRequerido = Singleton.getInstance().format(
                parcialidad.total
              );*/

                //const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");

                const fechaInicial = ""; /*format(
                parcialidad.fechaInicio,
                "dd-MMM-yyyy"
              );*/
                const fechaFin = ""; // format(parcialidad.fechaFin, "dd-MMM-yyyy");
                //const fechaRango = `${fechaInicial} - ${fechaFin}`;
                const fechaRango = ""; //`${fechaInicial}`;

                //  const start = new Date();
                /*start.setMonth(monthIndex);
                                start.setDate(1);*/
                //  const clientes = asociadosClientes[item.id] ?? [];
                const clientes = item.clientes;
                /*
              const item = value.asociado;
              const nombre = buildName(item, true);
              const totalPagar = Singleton.getInstance().format(value.total);
*/
                //      const start = new Date();
                /*start.setMonth(monthIndex);
                  start.setDate(1);*/

                /*    const fechaInicial = format(start, "yyyy-MMM-dd");
              const clientes = asociadosClientes[item.id] ?? [];*/

                const isClientLoading =
                  tDetalleIsShownRef.current[index] && clientes.length === 0;

                return (
                  <>
                    <tr
                      key={item.id}
                      onClick={(event) => toggleDetails(index, item.id)}
                    >
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>
                        <div className="">
                          <a
                            href="#"
                            onClick={(event) => openModals(index, item.id)}
                          >
                            {numAsociado}
                          </a>
                        </div>
                      </td>
                      <td style={{ textAlign: "left" }}>{nombre}</td>
                      <td style={{ textAlign: "center" }}>
                        {pendienteTotalParcialidad}
                      </td>
                      <td style={{ textAlign: "center" }}>{comision}</td>
                      <td style={{ textAlign: "center" }}>{usoPagina}</td>
                      <td style={{ textAlign: "center" }}>{pagoGuia}</td>
                      <td style={{ textAlign: "center" }}>{totalPagar}</td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          className={`btn btn-info ${toolTipStyles.tooltip}`}
                          style={{
                            marginLeft: "0px",
                            backgroundColor: "#81C784",
                          }}
                          onClick={(event) => {
                            console.log("--> openEDO CUENTA");
                            openEstadoCuenta(index, item.id);
                            event.stopPropagation();
                          }}
                        >
                          <div>
                            <span className={`${toolTipStyles.tooltiptext}`}>
                              Imprimir
                            </span>
                            <FaPrint />
                          </div>
                        </button>
                      </td>
                    </tr>
                    <tr
                      style={{
                        borderBottomColor: "transparent",
                      }}
                    >
                      <td
                        colSpan="12"
                        style={{
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          backgroundColor: "aliceblue",
                        }}
                      >
                        {/*<!-- Inner Table starts here -->*/}

                        {isClientLoading && (
                          <table
                            className="table table-borderless datable sortable table-hover"
                            style={{ backgroundColor: "lightcoral" }}
                            width="100%"
                          >
                            <tbody>
                              <SkeletonTable columnCount={7} rowCount={6} />
                            </tbody>
                          </table>
                        )}
                        <div
                          className=""
                          ref={(el) => (tDetalleRef.current[index] = el)}
                          style={{ display: "none" }}
                        >
                          {clientes.length === 0 ? (
                            <></>
                          ) : (
                            <>
                              <div className="col-1"></div>
                              <div className="col-11">
                                <table
                                  className="table table-borderless datable sortable table-hover"
                                  style={{ backgroundColor: "lightcoral" }}
                                  width="100%"
                                >
                                  <thead
                                    className="table-light"
                                    style={{ textAlign: "center" }}
                                  >
                                    <tr className={styles.has_tr}>
                                      <th
                                        scope="col"
                                        data-column="asociado.id"
                                        style={{
                                          width: "90px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Id
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Cliente
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          width: "140px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Total Abonado
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          width: "130px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        <span>Total Pendiente</span>
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          width: "150px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Comisión
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          width: "130px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Abono Quincenal
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.nombre"
                                        style={{
                                          textAlign: "center",
                                          width: "130px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={(event) => handleSort(event)}
                                      >
                                        Pago de la Quincena
                                      </th>

                                      <th
                                        scope="col"
                                        data-column="asociado.credito"
                                        onClick={(event) => handleSort(event)}
                                        style={{
                                          width: "150px",
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        Total a Pagar
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {clientes.map((itemCliente, index) => {
                                      const cliente = itemCliente.cliente;

                                      let nombreCliente = "Asociado";

                                      if (cliente != null) {
                                        nombreCliente = buildName(
                                          cliente,
                                          true,
                                        );
                                      }

                                      const numCliente =
                                        cliente?.numCliente ?? "-";

                                      const totalPagar =
                                        Singleton.getInstance().format(
                                          itemCliente.total,
                                        );

                                      const pendienteTotalParcialidad =
                                        Singleton.getInstance().format(
                                          itemCliente.pendienteTotalParcialidad,
                                        );

                                      const ordenParcialidades =
                                        itemCliente.ordenParcialidades;
                                      const parcialidadActual =
                                        ordenParcialidades.parcialidadActual;
                                      //  const parcialidadTotal =
                                      //  ordenParcialidades.totalParcialidades;
                                      /*  const numPago = `${
                                      parcialidadActual + 1
                                    } / ${parcialidadTotal}`;*/

                                      /*  const parcialidad =
                                        ordenParcialidades
                                          .productoParcialidades[
                                          parcialidadActual
                                        ];*/
                                      /*const pagoRequerido =
                                      Singleton.getInstance().format(
                                        parcialidad.total
                                      );*/

                                      const fechaInicial = "";
                                      /*format(
                                        parcialidad.fechaInicio,
                                        "dd-MMM-yyyy",
                                      );*/
                                      const fechaFin = "";
                                      /*const fechaFin = format(
                                        parcialidad.fechaFin,
                                        "dd-MMM-yyyy",
                                      );*/
                                      //const fechaRango = `${fechaInicial} - ${fechaFin}`;
                                      //const fechaRango = `${fechaInicial}`;
                                      const fechaRango = ""; //`${fechaInicial}`;

                                      /*  const totalPagar =
                                      Singleton.getInstance().format(
                                        itemCliente.total
                                      );

                                    const pendienteTotalParcialidad =
                                      Singleton.getInstance().format(
                                        itemCliente.pendienteTotalParcialidad
                                      );*/

                                      //  const start = new Date();
                                      /*start.setMonth(monthIndex);
                  start.setDate(1);*/

                                      //    const fecha = format(start, "yyyy-MMM-dd");

                                      return (
                                        <tr className={styles.has_tr}>
                                          <td
                                            style={{
                                              textAlign: "center",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            <a
                                              href="#"
                                              onClick={(e) =>
                                                openItem({
                                                  ...item,
                                                  itemCliente,
                                                })
                                              }
                                            >
                                              {numCliente}
                                            </a>
                                          </td>
                                          <td>{nombreCliente}</td>
                                          <td style={{ textAlign: "center" }}>
                                            {pendienteTotalParcialidad}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {comision}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {usoPagina}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {pagoGuia}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {totalPagar}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    {/*   <tr>
                                <td>Inner Table Cell 1, Row 2</td>
                                <td>Inner Table Cell 2, Row 2</td>
                              </tr> */}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          )}
                        </div>
                        {/*<!-- Inner Table ends here -->*/}
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
      {/** 
      <header className="App-header">
        <Line options={options} data={data} />
      </header>*/}

      {/* 
      <p>
        <a
          className="btn btn-primary"
          data-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Link with href
        </a>
        <button
          className="btn btn-primary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Button with data-target
        </button>
      </p>
      */}
      <div className="collapse" id="collapseExample">
        <div className="card card-body">
          {/* */}
          <div className="container33">
            <div className="entry33">
              <div className="name">name</div>
              <div className="type">type</div>
              <div className="value">value</div>
              <div className="extra">extra</div>
            </div>
            <details>
              <summary className="entry33">
                <div className="name">root</div>
                <div className="type">struct(620)</div>
                <div className="value">...</div>
              </summary>
              <div className="sub-entries" style={{ "--depth": 1 }}>
                <details>
                  <summary className="entry33">
                    <div className="name">header</div>
                    <div className="type">struct(12)</div>
                    <div className="value">...</div>
                  </summary>
                  <div className="sub-entries" style={{ "--depth": 2 }}>
                    <div className="entry33">
                      <div className="name">signature</div>
                      <div className="type">string(4)</div>
                      <div className="value">"XMPL"</div>
                    </div>
                    <div className="entry33">
                      <div className="name">version</div>
                      <div className="type">number(2)</div>
                      <div className="value">0</div>
                    </div>
                    <div className="entry33">
                      <div className="name">padding</div>
                      <div className="type">none(2)</div>
                      <div className="value">00</div>
                    </div>
                  </div>
                </details>
              </div>
            </details>
          </div>

          {/* */}
        </div>
      </div>

      {/*<table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              rowSpan={2}
              scope="col"
              data-column="asociado.id"
              style={{ width: "90px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              rowSpan={2}
              scope="col"
              data-column="asociado.nombre"
              style={{ verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
          
            <th
              colSpan={4}
              scope="col"
              className="no-sort"
              style={{ borderBottom: "solid" }}
            >
              Credito
            </th>

            <th
              rowSpan={2}
              scope="col"
              data-column="asociado.nivelId"
              style={{ width: "100px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Nivel
            </th>

            <th
              rowSpan={2}
              scope="col"
              data-column="sum"
              onClick={(event) => handleSort(event)}
              style={{ width: "190px", verticalAlign: "middle" }}
            >
              Calidad de Información
            </th>
            <th
              rowSpan={2}
              scope="col"
              data-column="asociado.activo"
              style={{ width: "100px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              data-column="asociado.limiteCredito"
              style={{ width: "140px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Limite
            </th>
            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{ width: "100px" }}
            >
              Dispuesto
            </th>
            <th
              scope="col"
              data-column="asociado.CredDisPor"
              onClick={(event) => handleSort(event)}
              style={{ width: "100px" }}
            >
              % Dispuesto
            </th>
            <th
              scope="col"
              data-column="asociado.CreditoDisponible"
              onClick={(event) => handleSort(event)}
            >
              Disponible
            </th>
          </tr>
        </thead>

        {isLoading && <SkeletonTable columnCount={9} rowCount={6} />}

        {!isLoading &&
          items?.length > 0 &&
          items?.map((data, index) => {
            const { sum, asociado } = data;
            const item = asociado;
            const nombre = buildName(item, true);

            const creditoDispuesto = Singleton.getInstance().format(
              item.credito
            );
            const limiteCredito = Singleton.getInstance().format(
              item.limiteCredito
            );
            const creditoDispuestoPer = item.credDisPor;
            const creditoDisponible = Singleton.getInstance().format(
              item.creditoDisponible
            );

            const detailCollapseId = `collapseExample-${index}`;
            const detailCollapseTarget = `#${detailCollapseId}`;

            return (
              <>
                <tbody>
                  <tr
                    key={item.id}
                    data-bs-toggle="collapse"
                    data-bs-target={detailCollapseTarget}
                  >
                    <td
                      style={{
                        verticalAlign: "middle",
                        justifyItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <a href="#" onClick={(e) => openItem(item)}>
                        {item.numAsociado ?? ""}
                      </a>
                    </td>
                    <td>
                      <a
                        href="#"
                        className="text-primary"
                        onClick={(e) => openItem(item)}
                      >
                        {nombre}
                      </a>
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {limiteCredito}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {creditoDispuesto}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {creditoDispuestoPer}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {creditoDisponible}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <span className={`badge ${handleNivel(item.nivel?.id)}`}>
                        {item.nivel?.nombre}
                      </span>
                    </td>

                    <td style={{ justifyContent: "center", display: "flex" }}>
                      <ProgressRing
                        radiusProp={25}
                        strokeProp={6}
                        strokeColor={"red"}
                        progress={sum}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="9" style={{ padding: "0px" }}>
                      <tbody
                        className="collapse"
                        id={detailCollapseId}
                        style={{ backgroundColor: "green" }}
                      >
                        <table
                          className="table table-borderless datable sortable table-hover"
                          style={{ tableLayout: "fixed" }}
                        >
                          <thead
                            className="table-light"
                            style={{ textAlign: "center" }}
                          >
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">First</th>
                              <th scope="col">Last</th>
                              <th scope="col">Handle</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td>Mark</td>
                              <td>Otto</td>
                              <td>@mdo</td>
                            </tr>
                            <tr>
                              <th scope="row">2</th>
                              <td>Jacob</td>
                              <td>Thornton</td>
                              <td>@fat</td>
                            </tr>
                            <tr>
                              <th scope="row">3</th>
                              <td>Larry</td>
                              <td>the Bird</td>
                              <td>@twitter</td>
                            </tr>
                          </tbody>
                        </table>
                      </tbody>
                    </td>
                  </tr>
                </tbody>
              </>
            );
          })}
      </table>*/}
    </>
  );
}
